<template>
  <div>
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Crianças"
            description="Crianças beneficiárias do Bolsa Família com atendimento odontológico"
            url="/indicadores-esb/estrategicos"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="maintenance">
            <i class="icofont-tools"></i>
            <h2>Em construção...</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle'

export default {
  name: 'Criancas',
  components: {
    SectionTitle,
  },

  data() {
    return {}
  },
}
</script>

<style></style>
